module.exports = "/_next/static/images/Aggregation@2x-769f7301ce245d43b92d0428256434ad.webp";